import React from "react";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";

import Home from "./screens/Home";
import Login from "./screens/Login";
import IncidentForm from "./screens/incidents/Form";
import Checklists from "./screens/checklists/List";
import CompletedChecklists from "./screens/checklists/Completed";
import ChecklistForm from './screens/checklists/Form';
import TaskForm from './screens/task/Form';
import Risks from './screens/risks/List';
import RiskForm from './screens/risks/Form';
import Documents from './screens/documents/List';

import './App.css';
import 'font-awesome/css/font-awesome.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min';

import env from './env';

const App = () => (
    <Router>
        <div className="container-fluid">
            <Route exact path={`${env.url}/`} component={Home} />
            <Route path={`${env.url}/login`} component={Login} />
            <Route path={`${env.url}/incidents/form`} component={IncidentForm} />
            <Route path={`${env.url}/tasks/form`} component={TaskForm} />
            <Route path={`${env.url}/checklists/list`} component={Checklists} />
            <Route path={`${env.url}/checklists/completed`} component={CompletedChecklists} />
            <Route path={`${env.url}/checklists/form/*`} component={ChecklistForm} />
            <Route path={`${env.url}/risks/form`} component={RiskForm} />
            <Route path={`${env.url}/risks/list`} component={Risks} />
            <Route path={`${env.url}/documents/list`} component={Documents} />
        </div>
    </Router>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js